import React from "react";
import { ArrowUpRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { WHATSAPP_URL } from "@/i18n/translations";
import { trackCTA, trackWhatsApp } from "@/lib/analytics";

const FinalCTA = () => {
  const { t } = useLang();
  const scrollLead = () => {
    const el = document.getElementById("lead");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  return (
    <section data-testid="final-cta-section" className="py-16 md:py-32 relative overflow-hidden">
      <div
        aria-hidden
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(50% 50% at 50% 50%, rgba(212,111,77,0.15), rgba(212,111,77,0) 70%)",
        }}
      />
      <div className="relative max-w-4xl mx-auto px-6 md:px-10 text-center">
        <h2 className="font-display font-light tracking-tighter text-maif leading-[0.95] text-5xl md:text-7xl">
          {t.finalCta.title_pre}{" "}
          <span className="font-accent italic text-terracotta">{t.finalCta.title_accent}</span>
          {t.finalCta.title_post}
        </h2>
        <p className="mt-6 text-maif-muted max-w-xl mx-auto">{t.finalCta.desc}</p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <button
            onClick={() => { trackCTA("start_project", "final_cta"); scrollLead(); }}
            data-testid="final-cta-primary"
            className="btn-primary"
          >
            {t.finalCta.primary}
            <ArrowUpRight size={18} />
          </button>
          <a
            href={WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="final-cta-secondary"
            onClick={() => trackWhatsApp("final_cta")}
            className="btn-secondary"
          >
            {t.finalCta.secondary}
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
